import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentDeletingError: {
    id: 'paymentDeletingError',
    defaultMessage: 'There was an error deleting your payment method.',
    description: 'Error while deleting a payment method.',
  },

  paymentAddingError: {
    id: 'paymentAddingError',
    defaultMessage:
      'Credit card details may be incorrect or we are experiencing issues with your card, please try again or check with your bank.',
    description: 'Error while adding a payment method.',
  },

  paymentLoadingError: {
    id: 'paymentLoadingError',
    defaultMessage: 'There was an error loading your payment method.',
    description: "Error while loading the user's payment methods.",
  },

  tooManyAddAccountAttempts: {
    id: 'tooManyAddAccountAttempts',
    defaultMessage:
      "You've tried adding a payment method too many times recently. Please try again later.",
    description: 'Error message displayed when user is throttled on addAccount mutation',
  },
});
